import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inputPlaceholder: {
    id: 'global.search.input.placeholder',
    defaultMessage: 'Search Bitbucket',
    description: 'Placeholder text shown in the Bitbucket search input',
  },
  refineYourSearch: {
    id: 'global.search.dialog.sectionHeader.refineYourSearch',
    defaultMessage: 'Refine your search',
    description: 'Section title for search refinement shortcuts',
  },
  recentlySearched: {
    id: 'global.search.dialog.sectionHeader.recentlySearched',
    defaultMessage: 'Recently searched',
    description: 'Section title for recent search queries',
  },
  recentlyUpdatedRepositories: {
    id: 'global.search.dialog.sectionHeader.recentlyUpdatedRepositories',
    defaultMessage: 'Recently updated repositories',
    description: 'Section title for recently updated repositories',
  },
  repositories: {
    id: 'global.search.dialog.sectionHeader.repositories',
    defaultMessage: 'Repositories',
    description: 'Section title for repositories when filtered by user input',
  },
  viewedRelativeDate: {
    id: 'global.search.dialog.recentSearch.viewedRelativeDate',
    defaultMessage: 'Viewed {relativeDate}',
    description:
      'Relative timestamp shown next to a recent search entry, e.g. "Viewed 3 hours ago"',
  },
  justViewed: {
    id: 'global.search.dialog.recentSearch.justViewed',
    defaultMessage: 'Just viewed',
    description:
      'Timestamp shown next to a recent search entry viewed less than a second ago',
  },
  updatedRelativeDate: {
    id: 'global.search.dialog.repository.updatedRelativeDate',
    defaultMessage: 'Updated {relativeDate}',
    description:
      'Relative timestamp shown next to a repository option, e.g. "Updated 12 hours ago"',
  },
  loadingRepositories: {
    id: 'bitbucket.search.dialog.repositories.loading',
    defaultMessage: 'Loading repositories',
    description:
      'Accessible label for the spinner shown while repository suggestions are loading',
  },
  searchCodeInBitbucket: {
    id: 'global.search.dialog.footer.searchCodeInBitbucket',
    defaultMessage: 'Search code in Bitbucket',
    description:
      'Label for the footer link that navigates to the code search page',
  },
  filterDescriptionRepo: {
    id: 'global.search.dialog.filter.repo.description',
    defaultMessage: 'Filter by repository',
    description: 'Description for the repo: search filter shortcut',
  },
  filterDescriptionLanguage: {
    id: 'global.search.dialog.filter.language.description',
    defaultMessage: 'Filter by language',
    description: 'Description for the language: search filter shortcut',
  },
  refineYourSearchRepository: {
    id: 'global.search.dialog.sectionHeader.refineYourSearchRepository',
    defaultMessage: 'Refine your search: repository',
    description:
      'Section title shown when the cursor is inside a repo: filter token',
  },
  loadingRepoFilterOptions: {
    id: 'bitbucket.search.dialog.repoFilter.loading',
    defaultMessage: 'Loading repository filter options',
    description:
      'Accessible label for the spinner shown while repo filter suggestions are loading',
  },
});
